<script setup lang="ts">
// live / every 2 s, for every preview at once (preview.ts)
import { previewLive, setPreviewLive } from '../../preview'
</script>

<template>
    <div class="flex w-fit overflow-hidden rounded-md border border-line-strong text-xs">
        <button
            class="rounded-none btn-ghost px-2.25 py-0.75"
            :class="{ 'bg-bg-3 text-fg': previewLive }"
            :aria-pressed="previewLive"
            @click="setPreviewLive(true)"
        >
            live</button
        ><button
            class="rounded-none btn-ghost px-2.25 py-0.75"
            :class="{ 'bg-bg-3 text-fg': !previewLive }"
            :aria-pressed="!previewLive"
            @click="setPreviewLive(false)"
        >
            every 2 s
        </button>
    </div>
</template>
